export { default as Service } from './Service';
export { default as ServiceProvider } from './ServiceProvider';
export { default as useService } from './ServiceRegistry';
export {
  injectedService,
  injectedHook,
  injectedComponent,
  registerDependencyInjections,
} from './DependencyInjection';
export { Text, useText } from './Text';
export { EMAIL_REGEXP } from '../constants/emailValidation';
export {
  normalizeFIO,
  normalizeCardholderName,
  CARDHOLDER_NAME_MAX_LENGTH,
} from '../constants/fioValidation';